import { BROWSER_CAPABILITIES } from 'utils/browserCapabilities';

import { EMediaPermissionsErrorType } from './IMediaCheck';

export interface IRejectReason {
  type: EMediaPermissionsErrorType;
  name: string;
  message: string;
}

export const requestMediaPermissions: (
  constraints?: MediaStreamConstraints,
) => Promise<boolean> = async (constraints) =>
  new Promise((resolve, reject) => {
    navigator.mediaDevices
      .getUserMedia(constraints ?? { audio: true, video: true })
      .then((stream: MediaStream) => {
        stream.getTracks().forEach((track) => {
          track.stop();
        });
        resolve(true);
      })
      .catch((err: Error) => {
        const errName: string = err.name;
        const errMessage: string = err.message;

        let errorType: EMediaPermissionsErrorType = EMediaPermissionsErrorType.GENERIC;
        if (BROWSER_CAPABILITIES.chrome) {
          if (errName === 'NotAllowedError') {
            if (errMessage === 'Permission denied by system') {
              errorType = EMediaPermissionsErrorType.SYSTEM_PERMISSION_DENIED;
            } else if (errMessage === 'Permission denied') {
              errorType = EMediaPermissionsErrorType.USER_PERMISSION_DENIED;
            }
          } else if (errName === 'NotReadableError') {
            errorType = EMediaPermissionsErrorType.COULD_NOT_START_VIDEO_SOURCE;
          }
        } else if (BROWSER_CAPABILITIES.safari) {
          if (errName === 'NotAllowedError') {
            errorType = EMediaPermissionsErrorType.USER_PERMISSION_DENIED;
          }
        } else if (BROWSER_CAPABILITIES.edge) {
          if (errName === 'NotAllowedError') {
            errorType = EMediaPermissionsErrorType.USER_PERMISSION_DENIED;
          } else if (errName === 'NotReadableError') {
            errorType = EMediaPermissionsErrorType.COULD_NOT_START_VIDEO_SOURCE;
          }
        } else if (BROWSER_CAPABILITIES.firefox) {
          // https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia#exceptions
          if (errName === 'NotFoundError') {
            errorType = EMediaPermissionsErrorType.SYSTEM_PERMISSION_DENIED;
          } else if (errName === 'NotReadableError') {
            errorType = EMediaPermissionsErrorType.SYSTEM_PERMISSION_DENIED;
          } else if (errName === 'NotAllowedError') {
            errorType = EMediaPermissionsErrorType.USER_PERMISSION_DENIED;
          } else if (errName === 'AbortError') {
            errorType = EMediaPermissionsErrorType.COULD_NOT_START_VIDEO_SOURCE;
          }
        }

        reject({
          type: errorType,
          name: err.name,
          message: err.message,
        });
        // Brave cannot be detected by the bowser library because they removed Brave from the User Agent to reduce fingerprinting
        // https://github.com/brave/browser-laptop/blob/master/CHANGELOG.md#090
      });
  });
